import { render, staticRenderFns } from "./team-impersonation-modal.vue?vue&type=template&id=566b0155"
import script from "./team-impersonation-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./team-impersonation-modal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports